import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "9.334",
      height: "9.334",
      x: "3.333",
      y: "3.333",
      stroke: "currentColor",
      "stroke-width": "1.125",
      rx: "1.333"
    }, null, -1),
    _createElementVNode("rect", {
      width: "4",
      height: "4",
      x: "6",
      y: "6",
      stroke: "currentColor",
      "stroke-width": "1.125",
      rx: ".667"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.125",
      d: "M5.333 1.333v2m2.667-2v2m2.667-2v2m-5.334 9.334v2m2.667-2v2m2.667-2v2M1.333 5.333h2M1.333 8h2m-2 2.667h2m9.334-5.334h2m-2 2.667h2m-2 2.667h2"
    }, null, -1)
  ]))]))
}
export default { render: render }